module.exports = __webpack_public_path__ + "img/worldofmakescents.c867cf9e.png";